import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
// import { scAxiosAdmin, thirdparty } from '../..';
// import { API_TOKEN_NAME } from '../../constants';
//import { startUserSession } from '../../userSession';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeftSidebar from "./LeftSidebar";
import TopHeader from "./TopHeader";
//import Footer from '../../component/admin/Footer';
//import CKEditor from "react-ckeditor-component";
import "./MultipleReactQuillEditor";
import { MultipleReactQuillEditor } from "./MultipleReactQuillEditor";
import SEO from "../Seo";
import { scAxiosAdmin, thirdparty } from "../..";

const editboardmember = (props) => {
  const [data, setData] = useState([]);
  //   console.log(props.match.params.id, "board_member user details ");
  const [formData, setFormData] = useState({
    designation: "",
    first_name: "",
    company: "",
    status: 1,
    image: null,
    serial_order: 0,
  });
  console.log(data, "hello");

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "doctor_id") {
      // Check if the select element is for doctor_id
      setFormData({
        ...formData,
        doctor_id: value,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    // Check if a file was selected
    if (file) {
      // Update the formData state by setting the author_profile_pic to the selected file
      setFormData({
        ...formData,
        image: file,
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await scAxiosAdmin(
          `/boardmembers/${props.match.params.id}`
        );
        console.log("response_data: ", response.data);
        setData(response.name);
        setFormData({
          ...formData,
          designation: response.data.designation,
          first_name: response.data.name,
          company: response.data.company,
          status: response.data.status,
          serial_order: response.data.serial_order,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await thirdparty.post(
        `/boardmembers_update/${props.match.params.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        toast.success("Board Member Updated successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        setTimeout(function () {
          window.location.href = "/admin/boardmembers";
        }, 3000);
      }
      console.log("Form data sent:", response.status);
    } catch (error) {
      console.error("Error submitting form:", error);
      // Handle errors, show error messages, etc.
    }
  };
  return (
    <div className="fixed-left">
      <SEO
        title="Edit Board Member"
        description="Edit Testimonials United Hospital"
        pathSlug="/boardmembers_update"
        keywords="Edit Testimonials, Testimonials"
      />
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="page-content-wrapper">
              <div className="col-lg-12">
                <div className="card m-b-20">
                  <div className="card-body">
                    {/* <h4 className="mt-0 header-title">Add Department</h4> */}

                    <form
                      id="adddepartmentform"
                      className="needs-validation"
                      noValidate
                      onSubmit={handleSubmit}
                    >
                      <div className="row">
                        <div className="col-sm-1">
                          <div className="form-group">
                            <label>Serial No.</label>
                            <input
                              type="number"
                              className="form-control"
                              name="serial_order"
                              id="serial_order"
                              value={formData.serial_order}
                              onChange={handleChange}
                              required
                              placeholder="Serial Number"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="name"
                              id="name"
                              value={formData.name}
                              onChange={handleChange}
                              required
                              placeholder="Name"
                            />
                            {/* <span style={alertStyle}>{this.state.errors.testimonial_title}</span> */}
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Designation</label>
                            <input
                              type="text"
                              className="form-control"
                              name="designation"
                              id="designation"
                              value={formData.designation}
                              onChange={handleChange}
                              required
                              placeholder="Designation"
                            />
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Company</label>
                            <input
                              type="text"
                              className="form-control"
                              name="company"
                              id="company"
                              value={formData.company}
                              onChange={handleChange}
                              required
                              placeholder="Company"
                              min="0"
                              max="5"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Board Member Image</label>
                            <input
                              type="file"
                              className="form-control"
                              name="image"
                              id="image"
                              onChange={handleFileChange}
                              accept="image/*" // Specify the accepted file types if needed
                              placeholder="Doctor Profile Pic"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="form-group">
                        <div>
                          <button
                            type="submit"
                            className="btn waves-effect waves-light"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default editboardmember;



// WEBPACK FOOTER //
// ./src/component/admin/editboardmember.js